import React, { useState } from "react";
import {
  DownlineHeader,
  formatDate,
  toFixedWithoutRounding,
} from "../Utils/Constant";
import ProfitLossCell from "../Utils/ProfitLossCell";

const ParlayBets = ({ data, filter, show, setShow, user }) => {
  return data?.map((item) => {
    return (
      <>
        <tr
          _ngcontent-serverapp-c84
          id="matchRow0"
          className="ng-star-inserted"
        >
          {DownlineHeader(user?.userType)?.map((res) => {
            return (
              <td className="align-L">{item[res?.key]?.username || "N/A"}</td>
            );
          })}
          <td _ngcontent-serverapp-c84 id="playerId" className="align-L">
            {item?.clientName || "-"}
          </td>
          <td _ngcontent-serverapp-c84 className="align-L">
            <a _ngcontent-serverapp-c84 id="betID" href="javascript: void(0);">
              {item?.matchBetId}
            </a>
          </td>
          <td _ngcontent-serverapp-c84 className="align-L ng-star-inserted">
            <span
              _ngcontent-serverapp-c84
              id="betPlaced"
              className="small-date"
            >
              {formatDate(item?.createdAt)}
            </span>
          </td>
          <td _ngcontent-serverapp-c84 className="align-L">
            <span _ngcontent-serverapp-c84 id="matchType">
              {" "}
              Parlay{" "}
              <img
                _ngcontent-serverapp-c84
                id="arrow"
                src="/assets/images/transparent.gif"
                className="fromto"
              />
              <strong _ngcontent-serverapp-c84>
                {item?.bets?.length == 1
                  ? "Single"
                  : item?.bets?.length == 2
                    ? "DOUBLE"
                    : item?.bets?.length == 3
                      ? "Triple"
                      : item?.bets?.length > 3
                        ? "ACCUMULATOR"
                        : ""}
              </strong>
            </span>
          </td>
          <td _ngcontent-serverapp-c84 className="align-L">
            <span _ngcontent-serverapp-c84 id="matchType" className="parlay">
              Parlay
            </span>
          </td>{" "}
          <td _ngcontent-serverapp-c84 className="align-L">
            <span _ngcontent-serverapp-c84 id="matchType" className="parlay">
              Parlay
            </span>
          </td>
          <td _ngcontent-serverapp-c84 id="matchOddsReq">
            {toFixedWithoutRounding(item?.bhav)}
          </td>
          <td
            _ngcontent-serverapp-c84
            id="matchStake"
            style={{ "white-space": "nowrap" }}
          >
            {item?.amount}
            <strong _ngcontent-serverapp-c84 className="ng-star-inserted">
              (USD)
            </strong>
          </td>
          <td _ngcontent-serverapp-c119>
            <span
              _ngcontent-serverapp-c119
              id="pol"
              className={"small-date loss-text"}
            >
              {Math.abs(item?.loseAmount)}
            </span>
          </td>
          <ProfitLossCell
            item={item}
            filter={filter}
            getBetType={filter?.type}
            styleBody={{}}
          />
          <td _ngcontent-serverapp-c84 id="matchSelection" className="align-R">
            <button
              onClick={() => {
                if (item?.bets?.length > 0) {
                  setShow({ status: true, data: item?.bets });
                }
              }}
              _ngcontent-serverapp-c84
              title="Void Bet"
              className="btn"
            >
              Details
            </button>
          </td>
          <td _ngcontent-serverapp-c84 id="ip" className="align-L">
            {(item?.ipAddress && item?.ipAddress.replace("::ffff:", "")) || "-"}
          </td>
        </tr>
      </>
    );
  });
};

export default ParlayBets;
